import styled from 'styled-components';
import { Button, Flex, textStyles } from '@bynder/design-system';

export const TitleWrapper = styled(Flex)`
    height: unset;
`;

export const Title = styled.h1<{ isBadgeShown?: boolean }>`
    ${textStyles.uiTextL}
    margin-bottom: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: max(
        calc(100vw - ${({ isBadgeShown }) => (isBadgeShown ? 775 : 695)}px),
        ${({ isBadgeShown }) => (isBadgeShown ? 440 : 520)}px
    );
`;

export const PublicStatus = styled.p`
    ${textStyles.uiTextS}
    margin-bottom: 0;
`;

export const PublishButtonStyled = styled(Button)`
    position: relative;
`;

export const PublishButtonIndicator = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    background-color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
`;
